import { Select, type SelectProps } from '@mantine/core'
import React from 'react'

import { ESystemLanguage } from '@flecto/types'
import { useLocaleName } from '@flecto/utils/src/Hooks/useLocaleName'

interface SelectLocaleProps
  extends Omit<SelectProps, 'data' | 'value' | 'defaultValue'> {
  value?: ESystemLanguage
  defaultValue?: ESystemLanguage
}

export const SelectLocale = ({ value, ...props }: SelectLocaleProps) => {
  const availableLocales = [
    { value: ESystemLanguage.EN, label: useLocaleName(ESystemLanguage.EN) },
    { value: ESystemLanguage.PT, label: useLocaleName(ESystemLanguage.PT) },
    { value: ESystemLanguage.ES, label: useLocaleName(ESystemLanguage.ES) },
  ]

  return (
    <Select
      data={availableLocales}
      data-testid='select-locale'
      value={value ?? undefined}
      defaultValue={value ?? undefined}
      {...props}
      searchable
    />
  )
}
